import { useTranslation } from 'next-i18next';

import { useAppSelector } from '@/redux';
import { NS } from '@/constants';

import MillesimaPrice from '@/components/common/price/MillesimaPrice';
import Badge from '@/components/common/badge/Badge';
import { ItemModel } from '@/models';
import { ACT_AS_BACKGROUND_COLOR } from '@/constants/gui';

export const MAX_STOCK_DISPLAYED = 12; // Change this value according to the backend

type BadgeForAdminProps = {
  item?: ItemModel;
  product?: {
    csrProductMarginAmount?: number;
    csrProductMarginRate?: number;
  };
  className?: string;
  isWineBox?: boolean;
}

export const BadgeForAdmin = ({
  item = {} as ItemModel, product, className, isWineBox = false
}: BadgeForAdminProps): React.JSX.Element => {
  const { t } = useTranslation(NS.COMMON);

  const locale = useAppSelector(({ root }) => root.storeConf.locale);
  const currency = useAppSelector(({ root }) => root.storeConf.currencyISO);
  const isNormalUser = useAppSelector(({ auth, admin }) => !(auth.loggedUser?.isAdmin || admin.actAsCustomer));
  const showAdminBadges = useAppSelector(({ user }) => user.settings.showAdminBadges);

  if (isNormalUser || !showAdminBadges) {
    return null;
  }

  let marginRate = Number(item.marge) || 0;
  let marginAmount;
  let hasValuesForCheckout = false;

  if (product) {
    marginRate = product.csrProductMarginRate;
    marginAmount = product.csrProductMarginAmount;
    hasValuesForCheckout = true;
  }

  const displayedStock = item.stock ? String(item.stock) + (item.stock === MAX_STOCK_DISPLAYED ? '+' : '') : 'N/A';

  if (isNaN(marginRate) || marginRate === 0) {
    marginRate = undefined;
  } else {
    marginAmount = '(' + MillesimaPrice.format(t, {
      value: hasValuesForCheckout ? marginAmount : ((marginRate / 100) * item.offerPrice),
      locale,
      currency
    }) + ')';
  }

  const qteVteMax = item?.attributes?.qte_vte_max ? item.attributes.qte_vte_max.value : null;

  return (
    <>
      {!isWineBox && (
        <Badge
          label={`Stock: ${displayedStock}`}
          bgColor={ACT_AS_BACKGROUND_COLOR}
          customClass={`mt-1 mr-1 p-1${className ? ' ' + className : ''}`}
        />
      )}
      <Badge
        label={`Marge: ${marginRate} % ${marginAmount}`}
        bgColor={ACT_AS_BACKGROUND_COLOR}
        customClass={`mt-1 mr-1 p-1${className ? ' ' + className : ''}`}
      />
      <Badge
        label={`Qte vente max: ${qteVteMax}`}
        bgColor={ACT_AS_BACKGROUND_COLOR}
        customClass={`mt-1 mr-1 p-1${className ? ' ' + className : ''}`}
      />
    </>
  );
};

export default BadgeForAdmin;
